/* ==========================================================================
   Kategorie · Produktliste — Verhalten der Filter
   Gehoert zu sections/fu-kategorie-raster.liquid (Custom Element
   <fu-kat-raster>). Plaene: Dokumentation/Plaene/Plan Kategorieseite -
   Filter oben.md (Phase A) und ... - Phase B.md; Baustein:
   Dokumentation/Bausteine/Filter.md.

   Was es tut:
   - Jede Aenderung im Filterformular baut die Adresse mit Shopifys
     Parametern (filter.v.*, filter.p.*, sort_by), traegt sie in den Verlauf
     ein (pushState) und holt die Sektion ueber die Section Rendering API
     (?section_id=). "Zurueck" im Browser nimmt den letzten Filter zurueck
     (popstate; behebt NEU-2 auf dieser Seite).
   - Ab 900 px klappt "Alle Filter" das Filterfeld ueber dem Raster auf, ein
     Schnellfilter oeffnet ein Menue mit einem Klon seiner Gruppe. Unter
     900 px ist das Feld ein Fenster von rechts mit Fokusfalle und
     Scroll-Sperre; ein Schnellfilter oeffnet es mit genau dieser Gruppe.
   - Phase B (Plan Kategorieseite - Phase B.md, Features 3, 6, 7):
     "{n} weitere Artikel laden" haengt die naechste Seite an (Abschnitt
     "Weitere laden"), der Preisregler schreibt in die Preisfelder
     (Abschnitt "Preisregler"), bildgroessen() tauscht das Handy-Ende von
     sizes, wenn der Besucher eine/zwei Spalten gewaehlt hat. Die Methoden
     sind oeffentlich wie der Rest der Klasse (im Plan "#bildgroessen()").

   Weitere laden und der Verlauf (G2 der Gegenpruefung):
   - Die Adresse bekommt page=N per replaceState, kein pushState: Sonst baute
     "Zurueck" Seite um Seite ab und loeste jedes Mal laden() aus.
     history.state wird uebernommen (Horizon sichert dort scrollTop) und
     traegt fuVon/fuBis: die Einstiegsseite und die zuletzt angehaengte.
   - Zurueck auf so einen Eintrag (etwa nach einem Filter): Liegen alle
     Seiten fuVon..fuBis im Zwischenspeicher, wird die Liste daraus sofort
     wieder aufgebaut, und Horizons Scroll-Wiederherstellung trifft die
     richtige Stelle. Fehlen hoechstens zwei, werden sie geholt und die
     Stelle danach gesetzt. Sonst laedt die Einstiegsseite, und die Liste
     steht oben (die gespeicherte Stelle passte nicht mehr). Damit der erste
     Fall der uebliche ist, merkt laden() beim Filtern die Einstiegsseite
     vor — sie stammt vom Server und lag nie im Zwischenspeicher.
   - Neu geladene Seite mit fuVon < page (F5 oder Zurueck ohne
     Back/Forward-Cache): Der Server liefert nur Seite N; die gespeicherte
     Stelle wird verworfen, die Liste steht oben.

   Warum nur Bereiche ausgetauscht werden (Gegenpruefung vom 30.09.2026,
   Fund 1): Horizons morph entfernt Attribute, die der Server nicht liefert,
   loescht Knoten ohne Gegenstueck und setzt Eingabefelder auf den
   Serverwert. Ein Morph ueber die ganze Sektion setzte Fenster, Menue,
   Suchtext und aria-Zustaende zurueck. Deshalb: Nur die Elemente mit
   data-fu-flt-bereich werden gemorpht; Zustaende des Skripts haengen an
   Elementen ausserhalb davon oder werden nach jedem Einbau von
   wiederherstellen() neu gesetzt.

   Abhaengigkeiten (lautlos, eingetragen in
   Dokumentation/Bausteine/Horizon-Aenderungen.md):
   - @theme/morph (assets/morph.js): Zuordnung ueber id — deshalb tragen die
     Werte eine stabile ID aus dem Wert, nicht aus der Position.
   - @theme/focus (assets/focus.js): trapFocus merkt sich erstes und letztes
     Element beim Aufruf — nach jedem Einbau neu aufrufen.
   - html[scroll-lock] aus assets/base.css als Scroll-Sperre.
   - @shopify/events (Shopifys CDN): CollectionUpdateEvent wie in
     assets/facets.js. Dynamisch importiert, damit ein Ladefehler das Filtern
     nicht mitreisst.
   - Der Kaufknopf der Kachel wird nach dem Austausch und nach dem Anhaengen
     vom MutationObserver in assets/fu-startseite.js freigegeben
     (Produktkachel.md, FIL-003).
   - @theme/scroll-container (assets/scroll-container.js): getIntersectionRoot
     fuer das Vorladen (ab 990 px scrollt .page-wrapper, nicht das Fenster),
     der pushState-Patch mit history.state.scrollTop und die
     Wiederherstellung bei popstate/pageshow.
   - Horizons Wortlaut der Kachelbilder: das erste img einer Karte ist das
     Titelbild, sizes endet auf dem Handy-Ende aus data-fu-sizes-* der Liste
     (sections/fu-kategorie-raster.liquid), a.product-card__link ist der
     Link der Karte (Fokusziel nach dem Anhaengen). morph behaelt sizes
     alter Knoten (assets/morph.js), deshalb laeuft bildgroessen() nach
     jedem Einbau.
   - Shopifys autosizes-Nachhilfe (Storefront-CDN, Safari < 27 und
     unbekannte Browser) schreibt Pixelwerte in sizes; bildgroessen()
     erkennt sie (siehe dort).
   ========================================================================== */

import { morph } from '@theme/morph';
import { trapFocus, removeTrapFocus } from '@theme/focus';
import { getIntersectionRoot, scrollContainerMediaQuery, scrollTo as fuScrollTo } from '@theme/scroll-container';

const GROSS = window.matchMedia('(min-width: 900px)');
const WENIG_BEWEGUNG = window.matchMedia('(prefers-reduced-motion: reduce)');
const KEIN_FORMULAR = 'fu-flt-kein-formular';
/** Tasten am Preisregler: 2 % bzw. 10 % der Skala (0-1000). */
const REGLER_SCHRITT = 20;
const REGLER_SPRUNG = 100;
/** Pause nach der letzten Taste, bevor der Regler filtert. */
const REGLER_UHR_MS = 350;

class FuKatRaster extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-fu-flt-form]');
    if (!this.form) return; // leere Kategorie: keine Filter

    this.feld = this.querySelector('[data-fu-flt-feld]');
    this.menue = this.querySelector('[data-fu-flt-menue]');
    this.schleier = this.querySelector('[data-fu-flt-schleier]');

    this.cache = new Map();
    this.anfrage = null;
    this.stand = window.location.search;
    this.feldOffen = false;
    this.menueKennung = null;
    /** Was das Feld geoeffnet hat: 'alle' oder die Kennung eines Schnellfilters. */
    this.ausloeserArt = null;
    /** Offen/zu je Gruppe, nur was der Besucher in dieser Darstellung gewaehlt hat. */
    this.gruppenOffen = new Map();
    /** Gruppen mit aufgeklapptem "weitere anzeigen". */
    this.gruppenAlle = new Set();
    /** Suchtext je Gruppe (Menue-Klone mit Praefix "m:"). */
    this.suche = new Map();

    /** Laufendes "weitere laden" (AbortController) und Vorladen der naechsten Seite. */
    this.nachladen = null;
    this.vorladen = null;
    /** Die vorgeladene Seite, schon zerlegt: { schluessel, doc }. */
    this.vorbereitet = null;
    this.beobachter = null;
    /** Vorgemerkte Einstiegsseite, solange sie unterwegs ist. */
    this.einstieg = null;
    /** Preisregler: Zeiger unten, Werte beim Zeigerdruck, Uhr nach Tasten. */
    this.reglerZieht = false;
    this.reglerZeiger = false;
    this.reglerStart = null;
    this.reglerUhr = null;
    /** Zuletzt bewegter Griff ('von' | 'bis'), fuer aufeinanderliegende Griffe. */
    this.reglerZuletzt = null;
    this.ansage = this.querySelector('[data-fu-kat-ansage]');

    this.addEventListener('change', this.beiAenderung);
    this.addEventListener('click', this.beiKlick);
    this.addEventListener('input', this.beiEingabe);
    this.addEventListener('keydown', this.beiTaste);
    this.addEventListener('pointerdown', this.beiZeigerUnten);
    this.addEventListener('toggle', this.beiToggle, true);
    this.form.addEventListener('submit', this.beiAbsenden);
    this.menue?.addEventListener('focusout', this.beiFokusWeg);
    document.addEventListener('click', this.beiKlickAussen);
    document.addEventListener('keydown', this.beiTasteAussen);
    window.addEventListener('popstate', this.beiVerlauf);
    GROSS.addEventListener('change', this.beiBreite);
    scrollContainerMediaQuery.addEventListener('change', this.beiScrollerWechsel);

    this.frischGeladen();
    this.wiederherstellen();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.beiKlickAussen);
    document.removeEventListener('keydown', this.beiTasteAussen);
    window.removeEventListener('popstate', this.beiVerlauf);
    GROSS.removeEventListener('change', this.beiBreite);
    scrollContainerMediaQuery.removeEventListener('change', this.beiScrollerWechsel);
    this.beobachter?.disconnect();
    this.nachladenAbbrechen();
    window.clearTimeout(this.reglerUhr);
    if (this.feldOffen) {
      removeTrapFocus();
      document.documentElement.removeAttribute('scroll-lock');
    }
  }

  get alleKnopf() {
    return this.querySelector('[data-fu-flt-alle]');
  }

  /** Der Knopf, der das Feld geoeffnet hat — frisch gesucht, weil morph die Leiste austauscht. */
  get ausloeserKnopf() {
    if (!this.ausloeserArt || this.ausloeserArt === 'alle') return this.alleKnopf;
    return this.querySelector(`[data-fu-flt-schnell="${this.ausloeserArt}"]`);
  }

  // ---------------------------------------------------------------- Ereignisse

  beiAenderung = (event) => {
    const el = event.target;
    if (!(el instanceof HTMLElement)) return;

    // Preisregler zuerst: Er hat keinen name, im Menue-Klon griffe sonst
    // spiegeln(). Natives change kommt beim Loslassen des Griffs und von
    // Hilfstechnik (Wischgesten), nie von den eigenen Pfeiltasten.
    if (el.matches('[data-fu-flt-regler-feld]')) {
      this.reglerLosgelassen(/** @type {HTMLInputElement} */ (el));
      return;
    }
    if (el.matches('[data-fu-flt-sort-spiegel]')) {
      const sort = this.form.querySelector('[data-fu-flt-sort]');
      if (sort) sort.value = /** @type {HTMLInputElement} */ (el).value;
      this.sortierungVerzoegert();
      return;
    }
    if (el.closest('[data-fu-flt-menue]')) {
      this.spiegeln(el);
      return;
    }
    if (el.matches('[data-fu-flt-suche]')) return;
    if (el.matches('[data-fu-flt-sort]')) {
      this.sortierungVerzoegert();
      return;
    }
    if (/** @type {HTMLInputElement} */ (el).form === this.form && el.getAttribute('name')) {
      this.anwenden();
    }
  };

  /**
   * Pfeiltasten in der Auswahlliste oder der Radiogruppe loesen je Taste ein
   * change aus. Kurz warten, damit nicht jede Zwischenstufe laedt und einen
   * Verlaufseintrag anlegt (Gegenpruefung nach dem Bau, Fund 6).
   */
  sortierungVerzoegert() {
    window.clearTimeout(this.sortUhr);
    this.sortUhr = window.setTimeout(() => this.anwenden(), 350);
  }

  beiAbsenden = (event) => {
    event.preventDefault();
    this.anwenden();
  };

  beiKlick = (event) => {
    const ziel = event.target instanceof Element ? event.target : null;
    if (!ziel) return;

    if (ziel.matches('[data-fu-flt-schleier]')) {
      this.feldSchliessen(true);
      return;
    }

    const t = ziel.closest('button, a');
    if (!t || !this.contains(t)) return;

    if (t.matches('[data-fu-flt-alle]')) return this.feldOffen ? this.feldSchliessen(true) : this.feldOeffnen(null, t);
    if (t.matches('[data-fu-flt-schnell]')) return this.schnellfilter(t);
    if (t.matches('[data-fu-flt-schliessen]')) return this.feldSchliessen(true);
    if (t.matches('[data-fu-flt-zeigen]')) return this.zeigen();
    if (t.matches('[data-fu-flt-menue-zuruecksetzen]')) return this.gruppeZuruecksetzen(this.menueKennung);
    if (t.matches('[data-fu-flt-mehr]')) return this.mehrUmschalten(t);
    if (t.matches('[data-fu-flt-stufe]')) return this.stufe(t);
    if (t.matches('[data-fu-flt-ansicht]')) return this.ansichtSetzen(t.getAttribute('data-fu-flt-ansicht'));
    if (t.matches('[data-fu-kat-nachladen]')) return this.mehrLaden(t);

    if (t.matches('[data-fu-flt-chip], [data-fu-flt-alle-entfernen]')) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
      event.preventDefault();
      this.entfernen(/** @type {HTMLAnchorElement} */ (t));
    }
  };

  beiKlickAussen = (event) => {
    if (!this.menueKennung) return;
    const ziel = event.target instanceof Element ? event.target : null;
    if (!ziel) return;
    if (this.menue.contains(ziel) || ziel.closest('[data-fu-flt-schnell]')) return;
    this.menueSchliessen(false);
  };

  beiEingabe = (event) => {
    const el = event.target;
    if (!(el instanceof HTMLInputElement)) return;
    // Griff bewegt (Ziehen, Hilfstechnik): Felder live schreiben, ohne Anfrage.
    if (el.matches('[data-fu-flt-regler-feld]')) {
      this.reglerBewegt(el);
      return;
    }
    // Eingabe im Preisfeld stellt den Regler sofort nach, ohne Anfrage.
    if (el.matches('[data-fu-flt-preis]')) {
      const regler = el.closest('.fu-flt-preis')?.querySelector('[data-fu-flt-regler]');
      if (regler instanceof HTMLElement) this.reglerAusFeldern(regler);
      return;
    }
    if (!el.matches('[data-fu-flt-suche]')) return;
    const inhalt = el.closest('.fu-flt-gruppe__inhalt');
    if (!inhalt) return;
    this.suche.set(this.inhaltSchluessel(inhalt), el.value);
    this.sucheAnwenden(inhalt, el.value);
  };

  beiTaste = (event) => {
    if (event.key === 'Escape') {
      if (this.menueKennung) {
        event.preventDefault();
        this.menueSchliessen(true);
      } else if (this.feldOffen) {
        event.preventDefault();
        this.feldSchliessen(true);
      }
      return;
    }
    if (event.target instanceof HTMLInputElement && event.target.matches('[data-fu-flt-regler-feld]')) {
      this.reglerTaste(event, event.target);
      return;
    }
    // Enter im Preisfeld ausdruecklich behandeln: Die Klone im Menue gehoeren
    // zu keinem Formular, und im Formular soll Enter nicht vom ersten (fuer
    // ohne Skript gedachten) Absendeknopf abhaengen.
    if (event.key === 'Enter' && event.target instanceof HTMLInputElement && event.target.matches('[data-fu-flt-preis]')) {
      event.preventDefault();
      if (event.target.closest('[data-fu-flt-menue]')) this.spiegeln(event.target);
      else this.anwenden();
    }
  };

  /**
   * Esc, waehrend der Fokus ausserhalb der Sektion liegt. Safari fokussiert
   * Knoepfe beim Mausklick nicht; nach einem Klick auf eine Preis-Stufe und
   * dem Neuaufbau lag der Fokus auf body, und Esc schloss das Menue nicht
   * (gefunden von ablauf.py in WebKit, 30.09.2026). Innerhalb der Sektion
   * gilt weiter beiTaste.
   */
  beiTasteAussen = (event) => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    // Nur wenn der Fokus nirgends liegt (body): Esc im Suchfeld des Kopfes
    // oder in einem anderen Fenster soll das Filterfeld nicht mitschliessen.
    const aktiv = document.activeElement;
    if (aktiv && aktiv !== document.body && aktiv !== document.documentElement) return;
    if (this.menueKennung) {
      event.preventDefault();
      this.menueSchliessen(true);
    } else if (this.feldOffen) {
      event.preventDefault();
      this.feldSchliessen(true);
    }
  };

  /** Verlaesst der Fokus das Menue per Tab, schliesst es (sonst verdeckt es den Fokus, WCAG 2.4.11). */
  beiFokusWeg = (event) => {
    if (!this.menueKennung) return;
    const neu = event.relatedTarget;
    if (!(neu instanceof Element)) return;
    if (this.menue.contains(neu) || neu.closest('[data-fu-flt-schnell]')) return;
    this.menueSchliessen(false);
  };

  beiToggle = (event) => {
    const d = event.target;
    if (!(d instanceof HTMLDetailsElement) || !d.matches('[data-fu-flt-gruppe]')) return;
    this.gruppenOffen.set(d.getAttribute('data-fu-flt-gruppe'), d.open);
  };

  beiVerlauf = () => {
    // Nur ueberspringen, wenn nichts laedt: Laeuft noch eine Anfrage fuer eine
    // andere Adresse, muss sie abgebrochen und der Stand der jetzigen Adresse
    // geholt werden — sonst baute sie sich nach "Zurueck" trotzdem ein
    // (Gegenpruefung nach dem Bau, Fund 1). Nach "weitere laden" steht in
    // this.stand die Adresse mit page=N; ein Anker und "Zurueck" landen
    // deshalb hier und lassen die lange Liste stehen (G2).
    if (!this.anfrage && window.location.search === this.stand) return;
    this.menueSchliessen(false);
    this.nachladenAbbrechen();

    const z = this.zustand();
    if (z.fuVon && z.fuBis > z.fuVon) {
      // Eintrag mit angehaengten Seiten: aus dem Zwischenspeicher sofort
      // wiederaufbauen — dann stellt Horizons popstate-Handler (rAF) die
      // gespeicherte Stelle auf der vollen Liste wieder her.
      if (this.wiederaufbauen(z.fuVon, z.fuBis)) return;
      this.wiederaufbauenNachLaden(z);
      return;
    }
    this.laden(window.location.href, { verlauf: false });
  };

  beiBreite = () => {
    this.feldSchliessen(false);
    this.menueSchliessen(false);
    this.gruppenOffen.clear();
    this.gruppenWiederherstellen();
  };

  /** Ab 990 px scrollt .page-wrapper: Das Vorladen braucht dann eine andere Wurzel. */
  beiScrollerWechsel = () => {
    this.nachladenVorbereiten();
  };

  // ---------------------------------------------------------------- Feld und Fenster

  feldOeffnen(kennung) {
    this.menueSchliessen(false);
    this.feldOffen = true;
    this.ausloeserArt = kennung || 'alle';

    if (!GROSS.matches) {
      // Im Fenster sind die Gruppen zu; ein Schnellfilter oeffnet nur seine.
      this.gruppenOffen.clear();
      this.form.querySelectorAll('details[data-fu-flt-gruppe]').forEach((d) => {
        this.gruppenOffen.set(d.getAttribute('data-fu-flt-gruppe'), false);
      });
      if (kennung) this.gruppenOffen.set(kennung, true);
    }

    this.feld.classList.add('is-offen');
    this.schleier?.classList.add('is-offen');
    this.wiederherstellen();

    if (!GROSS.matches) {
      document.documentElement.setAttribute('scroll-lock', '');
      this.feld.setAttribute('role', 'dialog');
      this.feld.setAttribute('aria-modal', 'true');
      trapFocus(this.feld);
      const ziel = kennung
        ? this.feld.querySelector(`[data-fu-flt-gruppe="${kennung}"] > summary`)
        : this.feld.querySelector('[data-fu-flt-schliessen]');
      window.requestAnimationFrame(() => {
        if (ziel instanceof HTMLElement) {
          ziel.focus();
          if (kennung) ziel.scrollIntoView({ block: 'start' });
        }
      });
    }
  }

  feldSchliessen(fokus) {
    if (!this.feldOffen) return;
    this.feldOffen = false;
    this.feld.classList.remove('is-offen');
    this.schleier?.classList.remove('is-offen');
    this.feld.setAttribute('role', 'region');
    this.feld.removeAttribute('aria-modal');
    document.documentElement.removeAttribute('scroll-lock');
    removeTrapFocus();
    this.wiederherstellen();
    if (fokus) {
      const ziel = this.ausloeserKnopf || this.alleKnopf;
      ziel?.focus();
    }
  }

  /** "{n} Produkte anzeigen": schliessen und zur Liste. */
  zeigen() {
    this.menueSchliessen(false);
    this.feldSchliessen(false);
    const liste = this.querySelector('#ResultsList');
    if (liste instanceof HTMLElement) {
      // 'instant' statt 'auto': Horizon setzt scroll-behavior: smooth, 'auto'
      // rollte also auch bei reduzierter Bewegung weich (FIL-005).
      liste.scrollIntoView({ block: 'start', behavior: WENIG_BEWEGUNG.matches ? 'instant' : 'smooth' });
      liste.focus({ preventScroll: true });
    }
  }

  // ---------------------------------------------------------------- Schnellfilter-Menue

  schnellfilter(knopf) {
    const kennung = knopf.getAttribute('data-fu-flt-schnell');
    if (!GROSS.matches) {
      this.feldOeffnen(kennung, knopf);
      return;
    }
    if (this.menueKennung === kennung) {
      this.menueSchliessen(true);
      return;
    }
    this.feldSchliessen(false);
    this.menueKennung = kennung;
    this.menueFuellen();
    if (!this.menueKennung) return;
    this.menue.hidden = false;
    this.menuePositionieren(knopf);
    this.wiederherstellen();
    const erstes = this.menue.querySelector('input:not([type=hidden]), button');
    if (erstes instanceof HTMLElement) erstes.focus();
  }

  menueFuellen() {
    const kennung = this.menueKennung;
    const quelle = this.form.querySelector(`[data-fu-flt-inhalt="${kennung}"]`);
    if (!quelle) {
      this.menueSchliessen(false);
      return;
    }
    const klon = /** @type {HTMLElement} */ (quelle.cloneNode(true));
    klon.removeAttribute('data-fu-flt-inhalt');
    klon.setAttribute('data-fu-flt-klon', kennung);
    klon.querySelectorAll('[id]').forEach((el) => {
      const alt = el.id;
      el.id = `${alt}-menue`;
      if (el instanceof HTMLInputElement) el.setAttribute('data-fu-flt-quelle', alt);
    });
    klon.querySelectorAll('label[for]').forEach((el) => {
      el.setAttribute('for', `${el.getAttribute('for')}-menue`);
    });
    klon.querySelectorAll('[aria-controls]').forEach((el) => {
      el.setAttribute('aria-controls', `${el.getAttribute('aria-controls')}-menue`);
    });
    klon.querySelectorAll('input, select').forEach((el) => {
      el.removeAttribute('name');
      el.setAttribute('form', KEIN_FORMULAR);
    });
    // Zustand der Quelle uebernehmen (Eigenschaften, nicht nur Attribute).
    klon.querySelectorAll('input[data-fu-flt-quelle]').forEach((el) => {
      const q = document.getElementById(el.getAttribute('data-fu-flt-quelle'));
      if (!(q instanceof HTMLInputElement) || !(el instanceof HTMLInputElement)) return;
      if (el.type === 'checkbox') el.checked = q.checked;
      else el.value = q.value;
    });

    const name = this.form.querySelector(`[data-fu-flt-gruppe="${kennung}"] .fu-flt-gruppe__name`);
    const titel = this.menue.querySelector('[data-fu-flt-menue-titel]');
    if (titel) titel.textContent = name ? name.textContent : '';
    const inhalt = this.menue.querySelector('[data-fu-flt-menue-inhalt]');
    inhalt?.replaceChildren(klon);

    const zeigenQuelle = this.querySelector('[data-fu-flt-bereich="fuss"] [data-fu-flt-zeigen]');
    const zeigenZiel = this.menue.querySelector('[data-fu-flt-zeigen-text]');
    if (zeigenZiel) zeigenZiel.textContent = zeigenQuelle ? zeigenQuelle.textContent.trim() : '';
  }

  /**
   * @param {HTMLElement} knopf
   * @param {boolean} [behalten] Nach dem Neuaufbau eines offenen Menues die
   *   waagerechte Lage behalten: Bekommt "Alle Filter" sein Zaehler-Badge,
   *   rueckt der Knopf "Preis" 28 px nach rechts, und das Menue sprang mit —
   *   der eben gezogene Griff stand nicht mehr unter dem Zeiger (Gegenpruefer
   *   tester, 01.10.2026). Korrigiert wird nur, wenn es aus dem Formular ragt.
   */
  menuePositionieren(knopf, behalten = false) {
    const basis = this.form.getBoundingClientRect();
    const r = knopf.getBoundingClientRect();
    const breite = this.menue.offsetWidth;
    let links = r.left - basis.left;
    // Passt das Menue rechts nicht mehr hin, oeffnet es nach links.
    if (links + breite > basis.width) links = Math.max(0, r.right - basis.left - breite);
    const bisher = parseFloat(this.menue.style.left);
    if (behalten && Number.isFinite(bisher)) links = Math.max(0, Math.min(bisher, basis.width - breite));
    this.menue.style.left = `${links}px`;
    this.menue.style.top = `${r.bottom - basis.top + 6}px`;
  }

  menueSchliessen(fokus) {
    if (!this.menueKennung) return;
    const kennung = this.menueKennung;
    this.menueKennung = null;
    this.menue.hidden = true;
    this.menue.querySelector('[data-fu-flt-menue-inhalt]')?.replaceChildren();
    this.querySelectorAll('[data-fu-flt-schnell]').forEach((k) => k.setAttribute('aria-expanded', 'false'));
    if (fokus) {
      const knopf = this.querySelector(`[data-fu-flt-schnell="${kennung}"]`);
      if (knopf instanceof HTMLElement) knopf.focus();
    }
  }

  /** Eingabe im Menue-Klon auf das Feld im Formular uebertragen. */
  spiegeln(el) {
    const id = el.getAttribute('data-fu-flt-quelle');
    const quelle = id ? document.getElementById(id) : null;
    if (!(quelle instanceof HTMLInputElement) || !(el instanceof HTMLInputElement)) return;
    if (el.type === 'checkbox') quelle.checked = el.checked;
    else quelle.value = el.value;
    this.anwenden();
  }

  gruppeZuruecksetzen(kennung) {
    if (!kennung) return;
    const inhalt = this.form.querySelector(`[data-fu-flt-inhalt="${kennung}"]`);
    if (!inhalt) return;
    inhalt.querySelectorAll('input').forEach((el) => {
      if (el.type === 'checkbox') el.checked = false;
      else if (el.hasAttribute('name')) el.value = '';
    });
    this.reglerAlle();
    this.anwenden();
  }

  // ---------------------------------------------------------------- Innerhalb einer Gruppe

  inhaltSchluessel(inhalt) {
    return inhalt.getAttribute('data-fu-flt-inhalt') || `m:${inhalt.getAttribute('data-fu-flt-klon')}`;
  }

  mehrUmschalten(knopf) {
    const inhalt = knopf.closest('.fu-flt-gruppe__inhalt');
    if (!inhalt) return;
    const an = !inhalt.hasAttribute('data-fu-flt-alle');
    const schluessel = this.inhaltSchluessel(inhalt);
    if (an) this.gruppenAlle.add(schluessel);
    else this.gruppenAlle.delete(schluessel);
    inhalt.toggleAttribute('data-fu-flt-alle', an);
    knopf.setAttribute('aria-expanded', String(an));
  }

  sucheAnwenden(inhalt, text) {
    const q = (text || '').trim().toLowerCase();
    let treffer = 0;
    inhalt.querySelectorAll('.fu-flt-wert').forEach((li) => {
      const passt = !q || (li.getAttribute('data-fu-flt-text') || '').includes(q);
      if (passt) {
        li.removeAttribute('data-fu-flt-treffer');
        treffer += 1;
      } else {
        li.setAttribute('data-fu-flt-treffer', 'nein');
      }
    });
    inhalt.toggleAttribute('data-fu-flt-sucht', Boolean(q));
    const leer = inhalt.querySelector('[data-fu-flt-suche-leer]');
    if (leer instanceof HTMLElement) leer.hidden = !(q && treffer === 0);
  }

  stufe(knopf) {
    const inhalt = this.form.querySelector('[data-fu-flt-inhalt="preis"]');
    if (!inhalt) return;
    const von = inhalt.querySelector('[data-fu-flt-preis="von"]');
    const bis = inhalt.querySelector('[data-fu-flt-preis="bis"]');
    if (!(von instanceof HTMLInputElement) || !(bis instanceof HTMLInputElement)) return;
    const aus = knopf.getAttribute('aria-pressed') === 'true';
    von.value = aus ? '' : knopf.getAttribute('data-von') || '';
    bis.value = aus ? '' : knopf.getAttribute('data-bis') || '';
    this.reglerAlle();
    this.anwenden();
  }

  // ---------------------------------------------------------------- Ansicht

  ansichtSetzen(wert) {
    if (wert === 'standard' || wert === 'kompakt') {
      this.setAttribute('data-ansicht-computer', wert);
      try {
        window.localStorage.setItem('fu-kat-ansicht-computer', wert);
      } catch (e) {
        /* ohne Speicher gilt die Wahl nur bis zum Neuladen */
      }
    } else if (wert === 'eine' || wert === 'zwei') {
      this.setAttribute('data-ansicht-handy', wert);
      try {
        window.localStorage.setItem('fu-kat-ansicht-handy', wert);
      } catch (e) {
        /* ohne Speicher gilt die Wahl nur bis zum Neuladen */
      }
    }
    this.ansichtAnwenden();
    this.bildgroessen();
  }

  ansichtAnwenden() {
    const computer = this.getAttribute('data-ansicht-computer') || 'standard';
    const handy = this.getAttribute('data-ansicht-handy') || 'zwei';
    this.querySelectorAll('[data-fu-flt-ansicht]').forEach((k) => {
      const wert = k.getAttribute('data-fu-flt-ansicht');
      k.setAttribute('aria-pressed', String(wert === computer || wert === handy));
    });
  }

  // ---------------------------------------------------------------- Laden

  anwenden() {
    const url = this.urlAusFormular();
    // Ohne page vergleichen: Nach "weitere laden" steht page=N in der
    // Adresse, das Formular kennt es nicht — Enter im unveraenderten
    // Preisfeld darf die Liste nicht auf eine Seite zuruecksetzen.
    if (this.schluessel(url, true) === this.schluessel(window.location.href, true)) return;
    this.laden(url, { verlauf: true });
  }

  /**
   * Liest einen Betrag, wie ihn Menschen tippen ("10", "10,5", "1.234,50").
   * Das letzte Trennzeichen mit hoechstens zwei Ziffern dahinter ist das
   * Dezimalzeichen, alle anderen sind Tausender. Kein Betrag: NaN.
   */
  betrag(text) {
    let s = String(text).replace(/\s/g, '');
    if (!/^\d[\d.,]*$/.test(s)) return NaN;
    const dez = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    if (dez >= 0 && s.length - dez - 1 <= 2) {
      s = `${s.slice(0, dez).replace(/[.,]/g, '')}.${s.slice(dez + 1)}`;
    } else {
      s = s.replace(/[.,]/g, '');
    }
    return Number(s);
  }

  urlAusFormular() {
    const daten = new FormData(this.form);
    const p = new URLSearchParams();
    for (const [schluessel, wert] of daten) {
      if (typeof wert !== 'string') continue;
      const w = wert.trim();
      if (!w) continue;
      // Preisfelder: nur echte, nicht negative Betraege (Gegenpruefung, Fund 7).
      if (/^filter\.v\.price\.(gte|lte)$/.test(schluessel) && !(this.betrag(w) >= 0)) continue;
      p.append(schluessel, w);
    }
    // "von 100 bis 10" meint 10 bis 100.
    const von = p.get('filter.v.price.gte');
    const bis = p.get('filter.v.price.lte');
    if (von && bis && this.betrag(von) > this.betrag(bis)) {
      p.set('filter.v.price.gte', bis);
      p.set('filter.v.price.lte', von);
    }
    // Die Standardsortierung gehoert nicht in die Adresse (NEU-28).
    if (p.get('sort_by') === this.getAttribute('data-standard-sort')) p.delete('sort_by');
    p.delete('page');
    const url = new URL(this.form.getAttribute('action') || window.location.pathname, window.location.origin);
    url.search = p.toString();
    return url.toString();
  }

  entfernen(link) {
    const chips = Array.from(this.querySelectorAll('[data-fu-flt-chip]'));
    const nr = chips.indexOf(link);
    const istChip = nr >= 0;
    this.laden(link.href, {
      verlauf: true,
      danach: () => {
        if (this.feldOffen && !GROSS.matches) {
          const zu = this.feld.querySelector('[data-fu-flt-schliessen]');
          if (zu instanceof HTMLElement) zu.focus();
          return;
        }
        if (istChip) {
          const neu = this.querySelectorAll('[data-fu-flt-chip]');
          const ziel = neu[Math.min(nr, neu.length - 1)];
          if (ziel instanceof HTMLElement) {
            ziel.focus();
            return;
          }
        }
        this.alleKnopf?.focus();
      },
    });
  }

  async laden(url, { verlauf, danach } = {}) {
    this.anfrage?.abort();
    this.nachladenAbbrechen();
    const anfrage = new AbortController();
    this.anfrage = anfrage;
    this.beschaeftigt(true);
    if (verlauf) {
      this.einstiegVormerken();
      window.history.pushState({ fuFilter: true }, '', url);
    }

    try {
      const html = await this.holen(url, anfrage.signal);
      if (anfrage.signal.aborted) return;
      this.einbauen(html);
      this.stand = new URL(url, window.location.origin).search;
      this.ereignisSenden();
      if (danach) danach();
    } catch (fehler) {
      if (fehler && fehler.name === 'AbortError') return;
      // Scheitert das Nachladen, laedt die Seite die Adresse ganz — kein
      // haengender Ladezustand.
      window.location.assign(url);
    } finally {
      if (this.anfrage === anfrage) {
        this.anfrage = null;
        this.beschaeftigt(false);
      }
    }
  }

  async holen(url, signal) {
    // Schluessel ohne Reihenfolge der Parameter und ohne page=1: Filter
    // (aus dem Formular) und Seiten (aus Shopifys paginate-Adressen) bauen
    // dieselbe Adresse verschieden.
    const schluessel = this.schluessel(url);
    if (this.cache.has(schluessel)) return this.cache.get(schluessel);
    const u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', this.getAttribute('data-section-id'));
    const antwort = await fetch(u.toString(), { signal, headers: { Accept: 'text/html' } });
    if (!antwort.ok) throw new Error(`HTTP ${antwort.status}`);
    const text = await antwort.text();
    // Hoechstens zehn Antworten merken: Jede ist die ganze Sektion, und
    // Bestand und Preise darin veralten im Lauf der Sitzung.
    this.cache.set(schluessel, text);
    if (this.cache.size > 10) this.cache.delete(this.cache.keys().next().value);
    return text;
  }

  /**
   * Vergleichbare Form einer Adresse: sortierte Parameter, ohne section_id,
   * ohne page=1 (oder ganz ohne page).
   */
  schluessel(url, ohneSeite = false) {
    const u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id');
    if (ohneSeite || u.searchParams.get('page') === '1') u.searchParams.delete('page');
    u.searchParams.sort();
    u.hash = '';
    return u.toString();
  }

  /** Dieselbe Adresse fuer Seite n (Seite 1 ohne page). */
  seitenUrl(url, n) {
    const u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id');
    if (n > 1) u.searchParams.set('page', String(n));
    else u.searchParams.delete('page');
    u.hash = '';
    return u.toString();
  }

  seiteAus(url) {
    const n = Number(new URL(url, window.location.origin).searchParams.get('page'));
    return Number.isInteger(n) && n > 1 ? n : 1;
  }

  /** history.state als Objekt (Horizon legt dort scrollTop ab). */
  zustand() {
    const z = window.history.state;
    return z && typeof z === 'object' ? z : {};
  }

  beschaeftigt(an) {
    const ergebnis = this.querySelector('[data-fu-flt-bereich="raster"]');
    if (ergebnis) ergebnis.setAttribute('aria-busy', String(an));
    if (an) {
      const zahl = this.querySelector('[data-fu-flt-zahl]');
      const text = this.getAttribute('data-text-laedt');
      if (zahl && text) zahl.textContent = text;
    }
  }

  einbauen(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const aktiv = document.activeElement;
    const fokusId = aktiv && this.contains(aktiv) && aktiv.id ? aktiv.id : null;
    // Ein Textfeld, in dem gerade getippt wird (etwa "bis", waehrend "von"
    // laedt), behaelt seinen Wert — morph setzte ihn sonst auf den des Servers
    // (Gegenpruefung nach dem Bau, Fund 2).
    const tippt = aktiv instanceof HTMLInputElement && aktiv.type === 'text' && this.form.contains(aktiv) ? aktiv.value : null;
    // Solange am Preisregler gezogen wird oder seine Uhr laeuft, gelten die
    // Preisfelder des Besuchers, nicht die einer spaeten Antwort — sonst
    // spraenge der Griff zurueck (Feature 7, "Sicherung vor dem Morph").
    const preisSicherung =
      this.reglerZieht || this.reglerUhr
        ? Array.from(this.form.querySelectorAll('[data-fu-flt-preis][id]')).map((f) => [f.id, f.value])
        : null;
    // morph stellt Range-Felder auf den Serverwert (0 bzw. 1000). Die
    // Stellung merken; reglerAlle() behaelt sie, solange sie zum Preisfeld
    // passt — sonst wanderte der Griff nach jeder Antwort um die Rundung.
    const reglerStand = Array.from(this.querySelectorAll('[data-fu-flt-regler-feld][id]')).map((f) => [
      f.id,
      /** @type {HTMLInputElement} */ (f).value,
    ]);

    this.querySelectorAll('[data-fu-flt-bereich]').forEach((alt) => {
      const name = alt.getAttribute('data-fu-flt-bereich');
      const neu = doc.querySelector(`[data-fu-flt-bereich="${name}"]`);
      if (neu) morph(alt, neu);
    });
    reglerStand.forEach(([id, wert]) => {
      const feld = document.getElementById(id);
      if (feld instanceof HTMLInputElement) feld.value = wert;
    });

    if (tippt !== null && fokusId) {
      const feld = document.getElementById(fokusId);
      if (feld instanceof HTMLInputElement && feld.value !== tippt) feld.value = tippt;
    }
    if (preisSicherung) {
      preisSicherung.forEach(([id, wert]) => {
        const feld = document.getElementById(id);
        if (feld instanceof HTMLInputElement) feld.value = wert;
      });
    }

    this.wiederherstellen();

    if (fokusId && (!document.activeElement || document.activeElement === document.body)) {
      const ziel = document.getElementById(fokusId);
      if (ziel instanceof HTMLElement) ziel.focus({ preventScroll: true });
    }
  }

  // ---------------------------------------------------------------- Zustand

  // Gruppen sind auf jeder Breite zu, bis der Besucher sie aufklappt (Timo,
  // 01.10.2026: "Standard soll eingeklappt sein"). Vorher standen sie im Feld
  // ab 900 px offen — bei 17 bis 24 Gruppen ein langes Feld, in dem man
  // die gesuchte Gruppe erst finden musste. Was der Besucher auf- oder
  // zuklappt, merkt gruppenOffen bis zum Breitenwechsel. Ohne Skript bleiben
  // die Gruppen offen (open im Markup, A14).
  gruppenWiederherstellen() {
    const standard = false;
    this.form.querySelectorAll('details[data-fu-flt-gruppe]').forEach((d) => {
      const kennung = d.getAttribute('data-fu-flt-gruppe');
      const soll = this.gruppenOffen.has(kennung) ? this.gruppenOffen.get(kennung) : standard;
      if (d.open !== soll) d.open = soll;
    });
  }

  /** Setzt alles, was nur das Skript weiss, nach jedem Einbau neu. */
  wiederherstellen() {
    this.gruppenWiederherstellen();

    this.form.querySelectorAll('[data-fu-flt-inhalt]').forEach((inhalt) => {
      const schluessel = this.inhaltSchluessel(inhalt);
      const alle = this.gruppenAlle.has(schluessel);
      inhalt.toggleAttribute('data-fu-flt-alle', alle);
      inhalt.querySelector('[data-fu-flt-mehr]')?.setAttribute('aria-expanded', String(alle));
      const text = this.suche.get(schluessel);
      const feld = inhalt.querySelector('[data-fu-flt-suche]');
      if (text && feld instanceof HTMLInputElement) {
        feld.value = text;
        this.sucheAnwenden(inhalt, text);
      }
    });

    this.alleKnopf?.setAttribute('aria-expanded', String(this.feldOffen && this.ausloeserArt === 'alle'));
    // Ab 900 px oeffnet ein Schnellfilter das Menue, darunter das Fenster —
    // aria-controls und aria-expanded folgen dem (Gegenpruefung, Fund 12).
    const gross = GROSS.matches;
    this.querySelectorAll('[data-fu-flt-schnell]').forEach((k) => {
      const kennung = k.getAttribute('data-fu-flt-schnell');
      k.setAttribute('aria-controls', gross ? this.menue.id : this.feld.id);
      const offen = gross ? kennung === this.menueKennung : this.feldOffen && this.ausloeserArt === kennung;
      k.setAttribute('aria-expanded', String(offen));
    });

    // Die Radiogruppe im Fenster liegt ausserhalb der ausgetauschten Bereiche
    // und folgt der Auswahlliste (etwa nach "Zurueck", Fund 5).
    const sort = this.form.querySelector('[data-fu-flt-sort]');
    if (sort instanceof HTMLSelectElement) {
      this.form.querySelectorAll('[data-fu-flt-sort-spiegel]').forEach((r) => {
        if (r instanceof HTMLInputElement) r.checked = r.value === sort.value;
      });
    }

    this.ansichtAnwenden();

    if (this.menueKennung) {
      const knopf = this.querySelector(`[data-fu-flt-schnell="${this.menueKennung}"]`);
      if (!knopf) {
        this.menueSchliessen(false);
      } else if (this.menue.querySelector('[data-fu-flt-klon]')) {
        // Fokus im Menue merken: ueber die Quelle (Eingabefelder) oder, bei
        // Knoepfen wie den Preis-Stufen, ueber die Position.
        const aktiv = document.activeElement;
        const imMenue = aktiv && this.menue.contains(aktiv);
        const fokusQuelle = imMenue ? aktiv.getAttribute('data-fu-flt-quelle') : null;
        const bedienbar = () => Array.from(this.menue.querySelectorAll('input, button'));
        const fokusNr = imMenue && !fokusQuelle ? bedienbar().indexOf(aktiv) : -1;
        this.menueFuellen();
        const klon = this.menue.querySelector('[data-fu-flt-klon]');
        if (klon) {
          const k = this.inhaltSchluessel(klon);
          klon.toggleAttribute('data-fu-flt-alle', this.gruppenAlle.has(k));
          klon.querySelector('[data-fu-flt-mehr]')?.setAttribute('aria-expanded', String(this.gruppenAlle.has(k)));
          const text = this.suche.get(k);
          const feld = klon.querySelector('[data-fu-flt-suche]');
          if (text && feld instanceof HTMLInputElement) {
            feld.value = text;
            this.sucheAnwenden(klon, text);
          }
        }
        this.menuePositionieren(knopf, true);
        if (fokusQuelle) {
          const ziel = document.getElementById(`${fokusQuelle}-menue`);
          if (ziel instanceof HTMLElement) ziel.focus({ preventScroll: true });
        } else if (fokusNr >= 0) {
          const ziel = bedienbar()[fokusNr];
          if (ziel instanceof HTMLElement) ziel.focus({ preventScroll: true });
        }
      }
    }

    if (this.feldOffen && !GROSS.matches) trapFocus(this.feld);

    this.reglerAlle();
    this.bildgroessen();
    this.nachladenVorbereiten();
  }

  // ---------------------------------------------------------------- Weitere laden (Feature 6)

  /**
   * Knopf freigeben (data-bereit macht ihn sichtbar) und die naechste Seite
   * eine Bildschirmhoehe vorher vorladen. So geschieht der Einbau im Klick,
   * und die Verschiebung zaehlt nicht zum CLS (hadRecentInput).
   */
  nachladenVorbereiten() {
    this.beobachter?.disconnect();
    this.beobachter = null;
    const knopf = this.querySelector('[data-fu-kat-nachladen]');
    if (!(knopf instanceof HTMLElement)) return;
    knopf.setAttribute('data-bereit', '');
    if (!this.nachladen) knopf.removeAttribute('aria-disabled');
    if (!('IntersectionObserver' in window)) return;
    const beobachter = new IntersectionObserver(
      (eintraege) => {
        if (!eintraege.some((e) => e.isIntersecting)) return;
        beobachter.disconnect();
        this.vorladenStarten(knopf);
      },
      { root: getIntersectionRoot(), rootMargin: '0px 0px 100% 0px' }
    );
    beobachter.observe(knopf);
    this.beobachter = beobachter;
  }

  vorladenStarten(knopf) {
    if (this.anfrage || this.nachladen) return;
    const roh = knopf.getAttribute('data-fu-kat-nachladen');
    if (!roh) return;
    const url = this.seitenUrl(roh, this.seiteAus(roh));
    const schluessel = this.schluessel(url);
    if (this.cache.has(schluessel) || this.vorladen?.schluessel === schluessel) return;
    const steuerung = new AbortController();
    const eintrag = { schluessel, steuerung, versprechen: this.holen(url, steuerung.signal) };
    this.vorladen = eintrag;
    eintrag.versprechen
      .then((text) => {
        // Schon jetzt zerlegen, in einer ruhigen Minute: Beim Klick bleibt
        // dann nur das Anhaengen. Laege das Zerlegen (750 KB HTML) im Klick,
        // kaeme die Verschiebung auf langsamen Geraeten spaeter als 500 ms
        // nach der Eingabe und zaehlte zum CLS.
        const leerlauf = window.requestIdleCallback || ((f) => window.setTimeout(f, 1));
        leerlauf(() => {
          if (steuerung.signal.aborted || this.nachladen) return;
          this.vorbereitet = { schluessel, doc: new DOMParser().parseFromString(text, 'text/html') };
        });
      })
      .catch(() => {
        /* Vorladen ist eine Zugabe; der Klick holt notfalls selbst. */
      })
      .finally(() => {
        if (this.vorladen === eintrag) this.vorladen = null;
      });
  }

  /** Bricht Nachladen und Vorladen ab (Filter, Zurueck). */
  nachladenAbbrechen() {
    this.nachladen?.abort();
    this.nachladen = null;
    this.vorladen?.steuerung.abort();
    this.vorladen = null;
    this.vorbereitet = null;
    this.platzFreigeben();
  }

  async mehrLaden(knopf) {
    // Doppelte Klicks und laufende Filteranfragen werden ignoriert.
    if (this.nachladen || this.anfrage) return;
    const roh = knopf.getAttribute('data-fu-kat-nachladen');
    if (!roh) return;
    const url = this.seitenUrl(roh, this.seiteAus(roh));
    const steuerung = new AbortController();
    this.nachladen = steuerung;
    // aria-disabled statt disabled: Der Fokus bleibt auf dem Knopf.
    knopf.setAttribute('aria-disabled', 'true');
    this.ansagen(this.getAttribute('data-text-laedt') || '');

    try {
      let html;
      const vor = this.vorladen;
      const fertig = this.vorbereitet;
      this.vorbereitet = null;
      if (fertig && fertig.schluessel === this.schluessel(url)) {
        html = fertig.doc;
      } else if (this.cache.has(this.schluessel(url))) {
        html = this.cache.get(this.schluessel(url));
      } else if (vor && vor.schluessel === this.schluessel(url)) {
        // Die Seite ist noch unterwegs: Platz halten, solange die Eingabe
        // frisch ist (siehe platzHalten), dann dasselbe Versprechen abwarten.
        this.platzHalten(knopf);
        // Die Seite ist schon unterwegs: dasselbe Versprechen abwarten,
        // keine zweite Anfrage.
        steuerung.signal.addEventListener('abort', () => vor.steuerung.abort(), { once: true });
        html = await vor.versprechen;
      } else {
        this.platzHalten(knopf);
        html = await this.holen(url, steuerung.signal);
      }
      if (steuerung.signal.aborted) return;
      this.platzFreigeben();

      const von = this.zustand().fuVon || this.seiteAus(window.location.href);
      const { neu, ansage } = this.anhaengen(html);
      // replaceState, kein pushState (siehe Kopf); history.state bleibt,
      // Horizon sichert dort scrollTop.
      window.history.replaceState({ ...this.zustand(), fuVon: von, fuBis: this.seiteAus(url) }, '', url);
      this.stand = window.location.search;

      // Fokus auf die erste neue Karte — auf der letzten Seite verschwindet
      // der Knopf, der Fokus fiele sonst auf body.
      const erste = neu[0];
      const link = erste ? erste.querySelector('a.product-card__link') || erste.querySelector('a[href]') : null;
      if (link instanceof HTMLElement) link.focus();
      this.ansagen(ansage);
    } catch (fehler) {
      if (steuerung.signal.aborted || (fehler && fehler.name === 'AbortError')) return;
      // Scheitert das Anhaengen, laedt die naechste Seite ganz — kein
      // haengender Knopf.
      window.location.assign(url);
    } finally {
      if (this.nachladen === steuerung) {
        this.nachladen = null;
        this.platzFreigeben();
        this.nachladenVorbereiten();
      }
    }
  }

  /**
   * Ist die naechste Seite beim Klick noch nicht da, haelt die Liste sofort
   * den Platz ihrer Reihen frei (Polster unten). Die Verschiebung faellt so
   * in die 500 ms nach der Eingabe und zaehlt nicht zum CLS; kommen die
   * Karten spaeter, fuellen sie den Platz, und was darunter liegt, springt
   * nicht mehr. Gemessen am 30.09.2026 mit 4G und vierfach gebremster CPU:
   * ohne Platzhalter CLS 0,38-0,47.
   */
  platzHalten(knopf) {
    const liste = this.querySelector('.fu-kat-raster__liste');
    const letzte = liste ? liste.lastElementChild : null;
    if (!(liste instanceof HTMLElement) || !(letzte instanceof HTMLElement)) return;
    const stil = window.getComputedStyle(liste);
    const spalten = stil.gridTemplateColumns.split(' ').filter(Boolean).length || 1;
    const abstand = parseFloat(stil.rowGap) || 0;
    const anzahl = Number(knopf.getAttribute('data-anzahl')) || spalten;
    const reihen = Math.ceil(anzahl / spalten);
    const hoehe = Math.round(reihen * (letzte.getBoundingClientRect().height + abstand));
    liste.style.paddingBottom = `${hoehe}px`;
    liste.style.setProperty('--fu-platz', `${hoehe}px`);
    // Sichtbarer Hinweis im freigehaltenen Platz (CSS: ::after).
    liste.setAttribute('data-fu-platz', this.getAttribute('data-text-laedt') || '');
  }

  platzFreigeben() {
    const liste = this.querySelector('.fu-kat-raster__liste');
    if (!(liste instanceof HTMLElement) || !liste.hasAttribute('data-fu-platz')) return;
    liste.style.removeProperty('padding-bottom');
    liste.style.removeProperty('--fu-platz');
    liste.removeAttribute('data-fu-platz');
  }

  /**
   * Haengt die Karten einer Sektionsantwort an die Liste und uebernimmt
   * Nachlade-Knopf und Blaetterleiste daraus (die Leiste zeigt dann die
   * zuletzt geladene Seite). Nimmt den Text der Antwort oder das schon
   * zerlegte Dokument aus dem Vorladen. Gibt die neuen Zeilen und den
   * Ansagesatz der Antwort zurueck.
   */
  anhaengen(html) {
    const doc = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
    const liste = this.querySelector('.fu-kat-raster__liste');
    const quelle = doc.querySelector('.fu-kat-raster__liste');
    const neu = [];
    if (!liste || !quelle) return { neu, ansage: '' };

    quelle.querySelectorAll(':scope > li').forEach((li) => {
      // Doppelte Karten (das Sortiment hat sich seit Seite 1 verschoben)
      // wuerden doppelte IDs ergeben.
      if (li.id && document.getElementById(li.id)) return;
      // Vor dem Einfuegen: Im Parser-Dokument laden Bilder noch nicht, im
      // Dokument saehen die Karten 1-5 der Antwort sonst "sofort" und "hoch".
      li.querySelectorAll('img').forEach((img) => {
        img.setAttribute('loading', 'lazy');
        img.removeAttribute('fetchpriority');
        const s = img.getAttribute('sizes');
        if (s && !/^\s*auto\s*,/.test(s)) img.setAttribute('sizes', `auto, ${s}`);
      });
      neu.push(li);
    });
    liste.append(...neu);

    ['[data-fu-kat-mehr-knopf]', '.fu-kat-raster__blaettern'].forEach((auswahl) => {
      const alt = this.querySelector(auswahl);
      const n = doc.querySelector(auswahl);
      if (alt && n) morph(alt, n);
    });

    this.gesehenZaehlen();
    this.bildgroessen();
    return { neu, ansage: quelle.getAttribute('data-ansage') || '' };
  }

  /** "Du siehst {x} von {y}" nach dem Anhaengen: x aus der Zahl der Karten. */
  gesehenZaehlen() {
    const zeile = this.querySelector('[data-fu-kat-gesehen]');
    const liste = this.querySelector('.fu-kat-raster__liste');
    const vorlage = zeile ? zeile.getAttribute('data-vorlage') : null;
    if (!zeile || !liste || !vorlage) return;
    const von = Number(zeile.getAttribute('data-von')) || 1;
    const x = von - 1 + liste.querySelectorAll(':scope > li').length;
    zeile.textContent = vorlage.replace('[x]', String(x));
  }

  /**
   * Zurueck auf einen Eintrag mit angehaengten Seiten: alle Seiten aus dem
   * Zwischenspeicher sofort wieder einbauen. false, wenn eine fehlt.
   */
  wiederaufbauen(von, bis) {
    const texte = [];
    for (let n = von; n <= bis; n += 1) {
      const text = this.cache.get(this.schluessel(this.seitenUrl(window.location.href, n)));
      if (!text) return false;
      texte.push(text);
    }
    this.anfrage?.abort();
    this.anfrage = null;
    this.einbauen(texte[0]);
    texte.slice(1).forEach((text) => this.anhaengen(text));
    this.stand = window.location.search;
    this.beschaeftigt(false);
    this.nachladenVorbereiten();
    return true;
  }

  /**
   * Fehlen nach "Zurueck" hoechstens zwei Seiten im Zwischenspeicher (etwa
   * die vorgemerkte Einstiegsseite ist noch unterwegs), werden sie geholt,
   * die Liste wird aufgebaut und die gespeicherte Stelle wiederhergestellt.
   * Fehlen mehr, laedt nur die Einstiegsseite, und die Liste steht oben —
   * die gespeicherte Stelle gehoerte zur langen Liste (G2).
   */
  async wiederaufbauenNachLaden(z) {
    const seiten = [];
    for (let n = z.fuVon; n <= z.fuBis; n += 1) seiten.push(this.seitenUrl(window.location.href, n));
    const fehlend = seiten.filter((u) => !this.cache.has(this.schluessel(u)));
    if (fehlend.length > 2) {
      this.einstiegLaden(z);
      return;
    }
    this.anfrage?.abort();
    const anfrage = new AbortController();
    this.anfrage = anfrage;
    this.beschaeftigt(true);
    try {
      await Promise.all(
        fehlend.map((u) => {
          const e = this.einstieg;
          return e && e.schluessel === this.schluessel(u) ? e.versprechen : this.holen(u, anfrage.signal);
        })
      );
      if (anfrage.signal.aborted) return;
      if (!this.wiederaufbauen(z.fuVon, z.fuBis)) throw new Error('Seite fehlt');
      // Horizons Wiederherstellung lief schon auf der alten Liste.
      if (Number.isFinite(z.scrollTop)) fuScrollTo({ top: z.scrollTop, behavior: 'instant' });
    } catch (fehler) {
      if (anfrage.signal.aborted || (fehler && fehler.name === 'AbortError')) return;
      if (this.anfrage === anfrage) this.anfrage = null;
      this.einstiegLaden(z);
    } finally {
      if (this.anfrage === anfrage) {
        this.anfrage = null;
        this.beschaeftigt(false);
      }
    }
  }

  /** Rueckfall: nur die Einstiegsseite, Adresse passend dazu, Liste oben. */
  einstiegLaden(z) {
    const url = this.seitenUrl(window.location.href, z.fuVon);
    const { scrollTop, ...rest } = z;
    window.history.replaceState({ ...rest, fuVon: z.fuVon, fuBis: z.fuVon }, '', url);
    this.laden(url, { verlauf: false, danach: () => this.zurListe() });
  }

  /**
   * Vor einem Filter nach "weitere laden": die Einstiegsseite in den
   * Zwischenspeicher holen, damit "Zurueck" die lange Liste sofort wieder
   * aufbauen kann (sie stammt vom Server und war nie abgerufen).
   */
  einstiegVormerken() {
    const z = this.zustand();
    if (!z.fuVon || !(z.fuBis > z.fuVon)) return;
    const url = this.seitenUrl(window.location.href, z.fuVon);
    const schluessel = this.schluessel(url);
    if (this.cache.has(schluessel) || this.einstieg?.schluessel === schluessel) return;
    const eintrag = { schluessel, versprechen: this.holen(url) };
    this.einstieg = eintrag;
    eintrag.versprechen
      .catch(() => {
        /* Ohne sie laedt "Zurueck" die Einstiegsseite neu. */
      })
      .finally(() => {
        if (this.einstieg === eintrag) this.einstieg = null;
      });
  }

  /**
   * Beim Laden der Seite: Stand history.state noch von einer langen Liste
   * (F5 nach "weitere laden", Zurueck ohne Back/Forward-Cache), liefert der
   * Server nur Seite N. Die gespeicherte Stelle gehoerte zur langen Liste
   * und fuehrte Richtung Fuss — verwerfen, oben an der Liste stehen.
   */
  frischGeladen() {
    const z = this.zustand();
    const seite = this.seiteAus(window.location.href);
    if (!z.fuVon || z.fuVon >= seite) return;
    const { scrollTop, ...rest } = z;
    window.history.replaceState({ ...rest, fuVon: seite, fuBis: seite }, '');
    // Unter 990 px stellt der Browser die Stelle selbst wieder her, ab 990 px
    // Horizon aus scrollTop (eben entfernt).
    try {
      window.history.scrollRestoration = 'manual';
    } catch (e) {
      /* aeltere Browser */
    }
    this.zurListe();
  }

  zurListe() {
    const liste = this.querySelector('#ResultsList');
    if (liste instanceof HTMLElement) liste.scrollIntoView({ block: 'start', behavior: 'instant' });
  }

  ansagen(text) {
    if (!this.ansage) return;
    window.clearTimeout(this.ansageUhr);
    this.ansage.textContent = '';
    if (!text) return;
    // Kurz leer, dann der Satz: So sagen Screenreader auch denselben Satz
    // ein zweites Mal an.
    this.ansageUhr = window.setTimeout(() => {
      if (this.ansage) this.ansage.textContent = text;
    }, 60);
  }

  // ---------------------------------------------------------------- Bildgroessen (Feature 3)

  /**
   * Der Server kennt nur die Einstellung "Produkte pro Reihe (Handy)"; wer
   * selbst auf eine bzw. zwei Spalten umschaltet, bekommt hier das passende
   * Ende von sizes (Safari ermittelt sizes=auto nicht selbst). Beim Start,
   * nach dem Ansichtswechsel, nach dem Morph und nach "weitere laden".
   *
   * Safari vor Version 27 (und jeder Browser, den Shopify nicht erkennt):
   * Shopifys Nachhilfe fuer sizes=auto (autosizes.js aus dem Storefront-CDN)
   * ersetzt bei verzoegerten Bildern "auto, ..." einmal durch die gezeichnete
   * Breite in px, etwa "163px". Nach dem Umschalten auf eine Spalte stimmte
   * der Wert nicht mehr, und Safari lud zu kleine Bilder (Gegenpruefung vom
   * 30.09.2026: 352er fuer 340 px bei DPR 2). Ein solcher Pixelwert, der
   * nicht mehr zur Breite passt, bekommt die ganze Kette zurueck
   * (data-fu-sizes-stamm + Ende): noch nicht geladen mit "auto, ", dann
   * rechnet die Nachhilfe ueber ihren MutationObserver neu; schon geladen
   * ohne "auto", dann waehlt Safari aus srcset neu.
   *
   * Spaltenzahl ("Produkte pro Reihe" 3 bis 6) und Bildbreite stecken ganz
   * im Stamm, den die Sektion rechnet; hier haengt nichts an ihnen. Am
   * 01.10.2026 mit 3, 4, 5 und 6 Spalten nachgemessen (Kollektion.md,
   * "Spalten der Produktliste"), auch nach Filter und "weitere laden".
   */
  bildgroessen() {
    const liste = this.querySelector('.fu-kat-raster__liste');
    if (!liste) return;
    const zwei = liste.getAttribute('data-fu-sizes-zwei');
    const eine = liste.getAttribute('data-fu-sizes-eine');
    const stamm = liste.getAttribute('data-fu-sizes-stamm');
    if (!zwei || !eine) return;
    const soll = this.getAttribute('data-ansicht-handy') === 'eine' ? eine : zwei;
    const weg = soll === eine ? zwei : eine;
    // Erst alles lesen, dann schreiben: getBoundingClientRect zwischen den
    // Schreibzugriffen erzwaenge je Bild eine neue Stilberechnung.
    const neu = [];
    liste.querySelectorAll('img[sizes]').forEach((img) => {
      const s = img.getAttribute('sizes') || '';
      if (s.endsWith(weg)) {
        neu.push([img, s.slice(0, s.length - weg.length) + soll]);
        return;
      }
      if (!stamm || !/^\s*\d+(\.\d+)?px\s*$/.test(s)) return;
      const breite = Math.round(img.getBoundingClientRect().width);
      if (breite > 0 && Math.abs(breite - parseFloat(s)) <= 1) return;
      const kette = stamm + soll;
      neu.push([img, !img.complete && img.getAttribute('loading') === 'lazy' ? `auto, ${kette}` : kette]);
    });
    neu.forEach(([img, wert]) => img.setAttribute('sizes', wert));
  }

  // ---------------------------------------------------------------- Preisregler (Feature 7)

  /** Richtet jeden Regler aus den Preisfeldern seiner Gruppe ein (auch zugeklappt, auch im Menue). */
  reglerAlle() {
    this.querySelectorAll('[data-fu-flt-regler]').forEach((r) => {
      if (r instanceof HTMLElement) this.reglerAusFeldern(r);
    });
  }

  reglerTeile(regler) {
    const preis = regler.closest('.fu-flt-preis');
    return {
      max: Number(regler.getAttribute('data-max')) / 100,
      von: regler.querySelector('[data-fu-flt-regler-feld="von"]'),
      bis: regler.querySelector('[data-fu-flt-regler-feld="bis"]'),
      feldVon: preis ? preis.querySelector('[data-fu-flt-preis="von"]') : null,
      feldBis: preis ? preis.querySelector('[data-fu-flt-preis="bis"]') : null,
    };
  }

  /** Preis -> Stellung 0..1, logarithmisch (wie Filtergruppe.dc.html). */
  reglerT(v, max) {
    if (!(max > 0)) return 0;
    return Math.min(1, Math.max(0, Math.log1p(v) / Math.log1p(max)));
  }

  /** Stellung -> Preis: unter 20 € auf 0,50 € gerundet, darueber auf ganze Euro. */
  reglerV(t, max) {
    const v = Math.expm1(t * Math.log1p(max));
    return v < 20 ? Math.round(v * 2) / 2 : Math.round(v);
  }

  /** Betrag, wie das Feld ihn zeigt: mit dem Dezimalzeichen des Ladens. */
  reglerBetrag(v, regler) {
    const dez = regler.getAttribute('data-dezimal') || '';
    return dez ? v.toFixed(2).replace('.', dez) : String(Math.round(v));
  }

  reglerText(v, regler) {
    const waehrung = regler.getAttribute('data-waehrung') || 'EUR';
    const sprache = document.documentElement.lang || 'de';
    const schluessel = `${sprache}|${waehrung}`;
    if (!this.reglerFormat || this.reglerFormat.schluessel !== schluessel) {
      try {
        this.reglerFormat = { schluessel, f: new Intl.NumberFormat(sprache, { style: 'currency', currency: waehrung }) };
      } catch (e) {
        this.reglerFormat = { schluessel, f: null };
      }
    }
    return this.reglerFormat.f ? this.reglerFormat.f.format(v) : this.reglerBetrag(v, regler);
  }

  reglerAusFeldern(regler) {
    const { max, von, bis, feldVon, feldBis } = this.reglerTeile(regler);
    if (!(von instanceof HTMLInputElement) || !(bis instanceof HTMLInputElement)) return;
    const a = feldVon instanceof HTMLInputElement ? this.betrag(feldVon.value) : NaN;
    const b = feldBis instanceof HTMLInputElement ? this.betrag(feldBis.value) : NaN;
    // Leer oder kein Betrag: Griff am Anfang bzw. Ende. Ein Wert ueber dem
    // hoechsten Preis stellt den Griff ans Ende, das Feld behaelt ihn.
    let tv = a > 0 ? this.reglerT(a, max) : 0;
    let tb = b >= 0 ? this.reglerT(b, max) : 1;
    // "von 100 bis 10" meint 10 bis 100 (wie urlAusFormular).
    if (tv > tb) [tv, tb] = [tb, tv];
    // Zeigt der Griff schon genau diesen Betrag (gerundet), bleibt er stehen:
    // Sonst wanderte er nach jeder Antwort um die Rundung zurueck, und die
    // naechste Pfeiltaste ergaebe keine vollen 2 %.
    const passt = (feld, t, betrag) => {
      const leer = !(betrag >= 0) || (feld === von && !(betrag > 0));
      const jetzt = Number(feld.value) / 1000;
      if (leer) return feld === von ? jetzt <= 0.005 : jetzt >= 0.995;
      return Math.abs(this.reglerV(jetzt, max) - betrag) < 0.005 && Math.abs(jetzt - t) < 0.02;
    };
    if (!passt(von, tv, a)) von.value = String(Math.round(tv * 1000));
    if (!passt(bis, tb, b)) bis.value = String(Math.round(tb * 1000));
    this.reglerZeichnen(regler);
  }

  /** Fuellung, Ebene der Griffe und aria-valuetext nach den Werten. */
  reglerZeichnen(regler) {
    const { max, von, bis, feldVon, feldBis } = this.reglerTeile(regler);
    if (!(von instanceof HTMLInputElement) || !(bis instanceof HTMLInputElement)) return;
    const tv = Number(von.value) / 1000;
    const tb = Number(bis.value) / 1000;
    regler.style.setProperty('--fu-von', String(tv));
    regler.style.setProperty('--fu-bis', String(tb));
    // Steht der untere Griff in der rechten Haelfte, liegt er oben — sonst
    // liesse er sich nicht greifen, wenn beide am Ende sitzen. Liegen beide
    // Griffe aufeinander, liegt der NICHT zuletzt bewegte oben: Wer "bis" auf
    // "von" geschoben hat, kann dann "von" weiter nach links ziehen und
    // umgekehrt (Gegenpruefer tester, 01.10.2026: sonst sass man fest).
    // Gemerkt am Element selbst, nicht am Regler: Der Morph nimmt Attribute,
    // die der Server nicht liefert, wieder weg. Es gibt nur einen Preisfilter.
    const deckung = Math.abs(tv - tb) < 0.012;
    const zuletzt = this.reglerZuletzt;
    von.toggleAttribute('data-oben', deckung && zuletzt ? zuletzt === 'bis' : tv > 0.5);
    const a = feldVon instanceof HTMLInputElement ? this.betrag(feldVon.value) : NaN;
    const b = feldBis instanceof HTMLInputElement ? this.betrag(feldBis.value) : NaN;
    von.setAttribute('aria-valuetext', this.reglerText(a >= 0 ? a : 0, regler));
    bis.setAttribute('aria-valuetext', this.reglerText(b >= 0 ? b : max, regler));
  }

  /** Griff bewegt: Stellung begrenzen, Preisfeld live schreiben — ohne Anfrage. */
  reglerBewegt(feld) {
    const regler = feld.closest('[data-fu-flt-regler]');
    if (!(regler instanceof HTMLElement)) return;
    const { max, von, bis, feldVon, feldBis } = this.reglerTeile(regler);
    if (!(von instanceof HTMLInputElement) || !(bis instanceof HTMLInputElement)) return;
    const art = feld.getAttribute('data-fu-flt-regler-feld');
    this.reglerZuletzt = art;
    let t = Number(feld.value) / 1000;
    // Die Griffe kreuzen sich nicht.
    t = art === 'von' ? Math.min(t, Number(bis.value) / 1000) : Math.max(t, Number(von.value) / 1000);
    feld.value = String(Math.round(t * 1000));

    // Am Anschlag (0,5 % Rand) bleibt das Feld leer: kein Filter auf dieser Seite.
    const leer = art === 'von' ? t <= 0.005 : t >= 0.995;
    const ziel = art === 'von' ? feldVon : feldBis;
    if (ziel instanceof HTMLInputElement) {
      ziel.value = leer ? '' : this.reglerBetrag(this.reglerV(t, max), regler);
      // Im Menue-Klon auch das Feld im Formular, das abgeschickt wird, und
      // den Regler dort.
      this.quelleSetzen(ziel);
    }
    this.quelleSetzen(feld);
    this.reglerZeichnen(regler);
  }

  /** Klon im Schnellfilter-Menue: Wert ins Original (data-fu-flt-quelle) uebertragen, ohne Anfrage. */
  quelleSetzen(el) {
    const id = el.getAttribute('data-fu-flt-quelle');
    const quelle = id ? document.getElementById(id) : null;
    if (quelle instanceof HTMLInputElement && quelle !== el) quelle.value = el.value;
  }

  reglerTaste(event, feld) {
    const w = Number(feld.value);
    const schritt = event.shiftKey ? REGLER_SPRUNG : REGLER_SCHRITT;
    let neu = null;
    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowDown':
        neu = w - schritt;
        break;
      case 'ArrowRight':
      case 'ArrowUp':
        neu = w + schritt;
        break;
      case 'PageDown':
        neu = w - REGLER_SPRUNG;
        break;
      case 'PageUp':
        neu = w + REGLER_SPRUNG;
        break;
      case 'Home':
        neu = 0;
        break;
      case 'End':
        neu = 1000;
        break;
      default:
        return;
    }
    // Eigene Schritte statt der nativen (0,1 %): 2 %, mit Umschalt 10 %.
    event.preventDefault();
    feld.value = String(Math.max(0, Math.min(1000, neu)));
    this.reglerBewegt(feld);
    this.reglerUhrStellen();
  }

  /** Die Anfrage folgt 350 ms nach der letzten Taste — nicht jede Zwischenstufe laedt. */
  reglerUhrStellen() {
    window.clearTimeout(this.reglerUhr);
    this.reglerUhr = window.setTimeout(() => {
      this.reglerUhr = null;
      this.anwenden();
    }, REGLER_UHR_MS);
  }

  reglerLosgelassen(feld) {
    this.reglerBewegt(feld);
    if (this.reglerZeiger) {
      // Loslassen nach dem Ziehen: genau eine Anfrage, sofort.
      this.reglerZeiger = false;
      window.clearTimeout(this.reglerUhr);
      this.reglerUhr = null;
      this.anwenden();
    } else {
      // Hilfstechnik (Wischgeste) aendert in Schritten: gebuendelt.
      this.reglerUhrStellen();
    }
  }

  beiZeigerUnten = (event) => {
    const feld = event.target;
    if (!(feld instanceof HTMLInputElement) || !feld.matches('[data-fu-flt-regler-feld]')) return;
    const regler = feld.closest('[data-fu-flt-regler]');
    if (!(regler instanceof HTMLElement)) return;
    const { von, bis, feldVon, feldBis } = this.reglerTeile(regler);
    const felder = [von, bis, feldVon, feldBis].filter((el) => el instanceof HTMLInputElement);
    // Die Originale im Formular gehoeren dazu, wenn der Regler im Menue steht.
    felder.slice().forEach((el) => {
      const id = el.getAttribute('data-fu-flt-quelle');
      const q = id ? document.getElementById(id) : null;
      if (q instanceof HTMLInputElement) felder.push(q);
    });
    this.reglerZieht = true;
    this.reglerZeiger = true;
    this.reglerStart = { regler, werte: felder.map((el) => [el, el.value]) };
    window.addEventListener('pointerup', this.beiZeigerOben);
    window.addEventListener('pointercancel', this.beiZeigerAbbruch);
  };

  beiZeigerOben = () => {
    window.removeEventListener('pointerup', this.beiZeigerOben);
    window.removeEventListener('pointercancel', this.beiZeigerAbbruch);
    const start = this.reglerStart;
    this.reglerZieht = false;
    this.reglerStart = null;
    // Nicht auf das native change verlassen: WebKit schickt keins, wenn das
    // Feld waehrend des Ziehens per Skript gesetzt wurde (Begrenzung der
    // Griffe, eine spaete Antwort). Hat sich etwas bewegt, filtert es hier —
    // genau eine Anfrage; ein nachfolgendes change findet dieselbe Adresse
    // vor und laedt nichts mehr (anwenden() vergleicht).
    if (start && start.werte.some(([el, wert]) => el.value !== wert)) {
      window.clearTimeout(this.reglerUhr);
      this.reglerUhr = null;
      this.reglerZeiger = false;
      this.anwenden();
      return;
    }
    // Das native change folgt noch in diesem Ablauf; kommt keins (Griff nicht
    // bewegt), gilt der naechste Anlass nicht mehr als Zeiger.
    window.setTimeout(() => {
      this.reglerZeiger = false;
    }, 0);
  };

  /** Der Browser hat die Geste uebernommen (senkrecht gewischt): Werte zurueck. */
  beiZeigerAbbruch = () => {
    window.removeEventListener('pointerup', this.beiZeigerOben);
    window.removeEventListener('pointercancel', this.beiZeigerAbbruch);
    const start = this.reglerStart;
    this.reglerZieht = false;
    this.reglerZeiger = false;
    this.reglerStart = null;
    if (!start) return;
    start.werte.forEach(([el, wert]) => {
      el.value = wert;
    });
    this.reglerZeichnen(start.regler);
  };

  // ---------------------------------------------------------------- Shopify-Ereignis

  ereignisSenden() {
    const roh = this.getAttribute('data-collection-id');
    const zahl = this.querySelector('[data-fu-flt-zahl]');
    const anzahl = Number(zahl ? zahl.getAttribute('data-anzahl') : 0) || 0;
    import('@shopify/events')
      .then(({ CollectionUpdateEvent }) => {
        const verzoegert = CollectionUpdateEvent.createPromise();
        const productFilters = CollectionUpdateEvent.parseProductFilters();
        this.dispatchEvent(
          new CollectionUpdateEvent({
            collection: {
              // Nur numerische IDs — "all" scheitert an der GID-Pruefung (assets/facets.js).
              id: roh && /^\d+$/.test(roh) ? roh : null,
              handle: this.getAttribute('data-collection-handle'),
              productsCount: anzahl,
            },
            ...(productFilters && { productFilters }),
            sortKey: CollectionUpdateEvent.getSortKey(),
            promise: verzoegert.promise,
          })
        );
        verzoegert.resolve({ productsCount: anzahl });
      })
      .catch(() => {
        /* Das Ereignis ist eine Zugabe; das Filtern haengt nicht daran. */
      });
  }
}

if (!customElements.get('fu-kat-raster')) {
  customElements.define('fu-kat-raster', FuKatRaster);
}
